export const APP_LOAD = 'APP_LOAD'
export const LOAD_BASE_COIN_ACCOUNT = 'LOAD_BASE_COIN_ACCOUNT'
export const REDIRECT = 'REDIRECT'
export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED'
export const HOME_PAGE_UNLOADED = 'HOME_PAGE_UNLOADED'
export const TRANSACTIONS_LOADED = 'TRANSACTIONS_LOADED'
export const TRANSACTIONS_UNLOADED = 'TRANSACTIONS_UNLOADED'
export const TRANSACTION_DETAIL_LOADED = 'TRANSACTION_DETAIL_LOADED'
export const TRANSACTION_DETAIL_UNLOADED = 'TRANSACTION_DETAIL_UNLOADED'
export const ACCOUNT_DETAIL_LOADED = 'ACCOUNT_DETAIL_LOADED'
export const ACCOUNT_DETAIL_UNLOADED = 'ACCOUNT_DETAIL_UNLOADED'
export const COIN_TRANSACTION_GO = 'COIN_TRANSACTION_GO'
export const ACCOUNT_GO = 'ACCOUNT_GO'
export const PAY_LOADED = 'PAY_LOADED'

export const ASYNC_START = 'ASYNC_START'
export const ASYNC_END = 'ASYNC_END'
export const SOCKET_MESSAGE_TRANSACTION_CREATED = 'TRANSACTION_CREATED'

export const REGISTER = 'REGISTER'
export const REGISTER_PAGE_UNLOADED = 'REGISTER_PAGE_UNLOADED'
export const LOGIN_GO = 'LOGIN_GO'
export const REGISTER_GO = 'REGISTER_GO'

export const LOGIN = 'LOGIN'
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED'
export const LOGOUT = 'LOGOUT'
export const GET_PIN_CODE = 'GET_PIN_CODE'
export const LOGIN_PAGE_VERIFY_PIN_CODE = 'LOGIN_PAGE_VERIFY_PIN_CODE'
export const VERIFY_PIN_CODE_UNLOADED = 'VERIFY_PIN_CODE_UNLOADED'
export const VERIFY_USER_PIN = 'VERIFY_USER_PIN'

//*****************settings ****************/
export const CATEGORY_LIST_PAGE_LOADED = 'CATEGORY_LIST_PAGE_LOADED'
export const CATEGORY_LIST_PAGE_UNLOADED = 'CATEGORY_LIST_PAGE_UNLOADED'
export const CATEGORY_ADD_PAGE_LOADED = 'CATEGORY_ADD_PAGE_LOADED'
export const CATEGORY_ADD_PAGE_UNLOADED = 'CATEGORY_ADD_PAGE_UNLOADED'
export const CATEGORY_DETAIL_PAGE_LOADED = 'CATEGORY_DETAIL_PAGE_LOADED'
export const CATEGORY_DETAIL_PAGE_UNLOADED = 'CATEGORY_DETAIL_PAGE_UNLOADED'
export const CATEGORY_UPDATE_PAGE_LOADED = 'CATEGORY_UPDATE_PAGE_LOADED'
export const CATEGORY_UPDATE_PAGE_UNLOADED = 'CATEGORY_UPDATE_PAGE_UNLOADED'
export const CATEGORY_ADD = 'CATEGORY_ADD'
export const CATEGORY_UPDATE = 'CATEGORY_UPDATE'
export const CATEGORY_DELETE = 'CATEGORY_DELETE'
export const PRODUCT_LIST_PAGE_LOADED = 'PRODUCT_LIST_PAGE_LOADED'
export const PRODUCT_LIST_PAGE_UNLOADED = 'PRODUCT_LIST_PAGE_UNLOADED'
export const PRODUCT_ADD_PAGE_LOADED = 'PRODUCT_ADD_PAGE_LOADED'
export const PRODUCT_ADD_PAGE_UNLOADED = 'PRODUCT_ADD_PAGE_UNLOADED'
export const PRODUCT_DETAIL_PAGE_LOADED = 'PRODUCT_DETAIL_PAGE_LOADED'
export const PRODUCT_DETAIL_PAGE_UNLOADED = 'PRODUCT_DETAIL_PAGE_UNLOADED'
export const PRODUCT_UPDATE_PAGE_LOADED = 'PRODUCT_UPDATE_PAGE_LOADED'
export const PRODUCT_UPDATE_PAGE_UNLOADED = 'PRODUCT_UPDATE_PAGE_UNLOADED'
export const PRODUCT_ADD = 'PRODUCT_ADD'
export const PRODUCT_UPDATE = 'PRODUCT_UPDATE'
export const PRODUCT_DELETE = 'PRODUCT_DELETE'

//**************** shopping cart *****************/ 
export const ADD_TO_CART = 'ADD_TO_CART'
export const REDUCE_FROM_CART = 'REDUCE_FROM_CART';
export const CART_LOADED = 'CART_LOADED'
export const RESET_CART = 'RESET_CART'

